import { useZonesForStructureCsvQuery } from '@/__generated__/graphql';
import { useCallback } from 'react';
import { useSnackBarMessage } from '@/utils/useSnackBarMessage';

export const useDownloadReport = (structureId: string, structureName: string) => {
  const { showSnackBar } = useSnackBarMessage({ variant: 'filled' });

  const { refetch } = useZonesForStructureCsvQuery({
    variables: {
      structureId: structureId as string,
    },
    skip: true,
  });

  const downloadCsvReport = useCallback(
    (rawCsvString: string) => {
      const CSV_FILE_TYPE = 'text/csv;charset=utf-8';

      const byteOrderMark = '\uFEFF';

      const csvBlob = new Blob([byteOrderMark, rawCsvString], {
        type: CSV_FILE_TYPE,
      });

      const name = structureName;

      // format 24-Aug-2023-08-43:AM
      const currentDateTime = new Date().toLocaleString('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });

      const fileName = `${name || 'structure'}-${currentDateTime}-report.csv`;

      const link = document.createElement('a');
      link.href = URL.createObjectURL(csvBlob);
      link.target = '_blank';
      link.download = fileName;
      link.style.display = 'none';
      document.body.append(link);
      link.click();
      link.remove();
    },
    [structureName]
  );

  const handleDownloadReport = useCallback(() => {
    refetch()
      .then((response) => {
        downloadCsvReport(response.data.zonesForStructureCSV);
      })
      .catch(() => {
        showSnackBar('Could not download report. Please try again later', 'error');
      });
  }, [downloadCsvReport, refetch, showSnackBar]);

  return {
    handleDownloadReport,
  };
};
